import { Fragment, useState } from "react";
import React from "react";
import {
  Dialog,
  Menu,
  Transition,
  Listbox,
  Disclosure,
  Combobox,
} from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
  ClipboardIcon,
  DocumentIcon,
  ShoppingCartIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Customervehiclemodalcreate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
    
      vehicle_information:"",
      query: "",
      selectedPerson: "",
      customer_id: 0,
      customerList: [],
      error_list: [],
      loader: "",
      overLay: "",
      fromInvoiceorcreatevehicle:this.props.customerId,
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open");
    this.setState({ sidebarOpen: true });
  };
  handleInputBranch = (e) => {
    this.props.handleInputBranch(e);
  };

  handleInputOne = (e) => {
    this.setState({
      query: e.target.value,
    });
  };

  handleInputCutomer = (e) => {
    this.setState({
      selectedPerson: e,
    });
    this.setState({ customer_id: e.id });
  };

  componentDidMount() {
    

    if(this.state.fromInvoiceorcreatevehicle){
      this.setState({customer_id:this.state.fromInvoiceorcreatevehicle});
    }

    this.setLoaderFunction();
    const token = localStorage.getItem("token");

    this.state.customerList = [];
    const res = axios
      .get("public/api/customers", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ customerList: res.data.customers });
      });
    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
        //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  handleInput = (e) => {
    var token = localStorage.getItem("token");

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  saveItem = async (e) => {
    e.preventDefault();
    this.setLoaderFunction();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/vehicle/information/customer/store", this.state, {
      headers,
    });

    if (res.data.success) {
      this.setState({ showmsg: true });
      this.closeLoaderFuncion();
      setTimeout(function () {}.bind(this), 2000);
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
    this.closeLoaderFuncion();
    this.handleInputBranch(res.data.success);
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      //return <Navigate to={"/BranchList"} />;
    }

    const filteredPeople =
      this.state.query === ""
        ? this.state.customerList
        : this.state.customerList.filter((customerList) => {
            return customerList.customer_display_name
              .toLowerCase()
              .includes(this.state.query.toLowerCase());
          });
    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Static sidebar for desktop */}

          <div className="lg: flex flex-col flex-1">
            <main className="flex-1 ">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    New Vehicle
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.saveItem}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                {this.state.fromInvoiceorcreatevehicle!=0?(""):(<div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <Combobox
                                    as="div"
                                    name="customer_id"
                                    value={this.state.selectedPerson}
                                    onChange={this.handleInputCutomer}
                                  >
                                    <Combobox.Label className="block text-sm font-medium text-gray-700">
                                      <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                        Customer
                                      </span>
                                    </Combobox.Label>
                                    <div className="relative mt-1">
                                      <Combobox.Input
                                        className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                        onChange={this.handleInputOne}
                                        displayValue={(cutomer) =>
                                          typeof cutomer.customer_display_name !==
                                            "undefined" &&
                                          cutomer.customer_display_name !=
                                            null
                                            ? cutomer.customer_display_name
                                            : ""
                                        }
                                      />
                                      <Combobox.Button className="absolute inset-y-0 right-9 flex items-center rounded-r-md px-2 focus:outline-none">
                                        <SelectorIcon
                                          className="h-5 w-5 text-gray-400"
                                          aria-hidden="true"
                                        />
                                      </Combobox.Button>

                                      {filteredPeople.length > 0 && (
                                        <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                          {filteredPeople.map((customer) => (
                                            <Combobox.Option
                                              key={customer.id_crypt}
                                              value={customer}
                                              className={({ active }) =>
                                                classNames(
                                                  "relative cursor-default select-none py-2 pl-3 pr-9",
                                                  active
                                                    ? "bg-indigo-600 text-white"
                                                    : "text-gray-900"
                                                )
                                              }
                                            >
                                              {({ active, selected }) => (
                                                <>
                                                  <span
                                                    className={classNames(
                                                      "block truncate",
                                                      selected &&
                                                        "font-semibold"
                                                    )}
                                                  >
                                                    {
                                                      customer.customer_display_name
                                                    }
                                                  </span>

                                                  {selected && (
                                                    <span
                                                      className={classNames(
                                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                                        active
                                                          ? "text-white"
                                                          : "text-indigo-600"
                                                      )}
                                                    >
                                                      <CheckIcon
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                      />
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                            </Combobox.Option>
                                          ))}
                                        </Combobox.Options>
                                      )}
                                    </div>
                                  </Combobox>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.customer_id}
                                  </p>
                                </div>)}
                                
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="vehicle_information"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Vehicle info
                                  </label>
                                  <input
                                    type="text"
                                    name="vehicle_information"
                                    id="vehicle_information"
                                    onChange={this.handleInput}
                                    
                                    autoComplete="vehicle_information"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="vehicle_information-error"
                                  >
                                    {this.state.error_list.vehicle_information}
                                  </p>
                                </div>
                                </div>
                               
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Created
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default Customervehiclemodalcreate;
